<template>
  <view class="c-nav-header" id="navbar" :style="navOuterStyle">
    <view class="fill" :style="navFillStyle" v-if="fixed && autoFill" />

    <view class="inner" :class="{ fixed: !!fixed, shadow: shadow }" :style="navStyle">
      <view class="statu-bar" :style="statuBarStyle"></view>

      <view class="main" :style="mainStyle">
        <!-- 左插槽 优先插槽元素，其次返回元素 -->
        <template v-if="hasLeftSlot">
          <slot name="leftSolt" />
        </template>


        <template v-else-if="displayReturnBack">
          <view class="back" @click="handleReturnBack">
            <c-img
              v-if="
                backgroundColor === 'black' ||
                backgroundColor === 'none' ||
                styleTheme === 'dark'
              "
              :size="48"
              remote-name="left_arrow_w"
            />
            <c-img v-else :size="48" remote-name="left_arrow_b" />
          </view>
        </template>















        <!-- 主插槽 优先插槽元素，其次标题元素 -->
        <template v-if="hasMainSlot">
          <slot />
        </template>
        <template v-else-if="!!pageTitle">
          <view
            class="title"
            :class="{ 'light-title': styleTheme === 'dark' }"
            @click.stop="handleTitleClick"
          >
            {{ pageTitle }}
          </view>
        </template>

      </view>
    </view>
  </view>
</template>

<script setup lang="ts">
import { PAGE_PATH } from '@/constants';
import { useAppStore, useUserStore } from '@/store';
import type { Themes } from '@/types';
import { businessUtils, commonUtils } from '@/utils';
import { computed, getCurrentInstance, onMounted, toRefs, useSlots } from 'vue';

/**
 * 注：所有涉及和关联navbar的布局样式，比如下拉时间弹窗组件的定位等；尽量使用px，rpx在不同机型下的适配有误，暂无时间排查解决方案，后续完善。
 */
interface Props {
  /** 标题 */
  title?: string;
  /** 是否展示页面标题 */
  displayTitle?: boolean;
  /** 是否展示返回按钮 */
  displayReturnBack?: boolean;
  /** 是否展示客服按钮 */
  displayCustomerService?: boolean;
  /** 是否固定顶部 */
  fixed?: boolean;
  /** 自定义返回事件，需传入相关事件 */
  customBack?: boolean;
  /** 背景颜色 */
  backgroundColor?: string;
  /** 描述格调风格颜色，影响标题栏文本颜色和返回按钮的颜色 */
  styleTheme?: Themes;
  /** 是否展示阴影 */
  shadow?: boolean;
  /** 是否自动填充fixed定位下的空缺 */
  autoFill?: boolean;
  /** 最外层样式 */
  navOuterStyle?: AnyObject;
}
const props = withDefaults(defineProps<Props>(), {
  title: '',
  displayTitle: true,
  displayReturnBack: true,
  displayCustomerService: false,
  fixed: true,
  customBack: false,
  backgroundColor: '#ffffff',
  shadow: true,
  autoFill: true,
});
const {
  title,
  displayTitle,
  displayReturnBack,
  fixed,
  customBack,
  backgroundColor,
  styleTheme,
  shadow,
  navOuterStyle,
} = toRefs(props);

const emits = defineEmits(['back', 'rect']);

let testNum = 0;

const userStore = useUserStore();
const appStore = useAppStore();

const navBarInfos = commonUtils.navbar.get();

const slots = useSlots();
const hasLeftSlot = !!slots.leftSolt;
const hasMainSlot = !!slots.default;

/** 组件样式 */
const navStyle = computed(() => ({
  background: `${backgroundColor?.value || ''}`,
  color: backgroundColor?.value === 'black' || backgroundColor?.value === 'none' ? 'white' : 'black',
}));

// 状态栏样式
const statuBarStyle = computed(() => ({ height: `${navBarInfos.menuButtonInfo.top}px` }));

// 主体样式
const mainStyle = computed(() => ({
  height: `${navBarInfos.menuButtonInfo.height}px`,
  padding: `0 ${navBarInfos.rightPaddingValue}px 0 0`,
}));

const navFillStyle = computed(() => ({
  height: `${navBarInfos.menuButtonInfo.top + navBarInfos.menuButtonInfo.height + 6}px`,
}));

const pageTitle = computed(() => {
  if (!displayTitle.value) return '';

  if (title.value) return title.value;

  const pageList = Object.values(PAGE_PATH);

  const pages = getCurrentPages();
  const currentPage = pages[pages.length - 1];

  const target = pageList.find((it) => it.route === `/${currentPage.route}`);

  return target?.title ?? '';
});

const handleReturnBack = () => {
  if (customBack.value) {
    emits('back');
    return;
  }
  commonUtils.page.back();
};

const handleTitleClick = () => {
  if (testNum === -1) {
    appStore.testAuthElement = false;
    testNum++;
  } else if (testNum >= 30) {
    appStore.testAuthElement = true;
    testNum = -1;
  } else {
    testNum++;
  }
};

onMounted(async () => {
  const rect = await commonUtils.mp.getRect('#navbar', getCurrentInstance());
  emits('rect', rect);
});
</script>

<style scoped lang="scss">
.c-nav-header {
  position: relative;
  z-index: 9980;

  .fill {
    width: 100%;

    // display: none;

  }
  .inner {
    position: relative;
    z-index: 990;
    padding-bottom: 6px;


    // display: none;


    &.shadow {
      @include topShadow;
    }

    &.fixed {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 991;
      // background: $W;
    }

    .statu-bar {
      width: 100%;
      // background: $W;
    }

    .main {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;

      .back {
        @include scaleTouch();
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 12px;
      }

      .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 375rpx;
        font-size: 32rpx;
        font-weight: bold;
        font-family: PingFangSC-Semibold, PingFang SC;
        @include overflowEllipsis;

        &.light-title {
          color: $W;
        }
      }
    }
  }
}
</style>
